import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { Zone, ZoneBranch } from "./zone.model";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";

export class ZonePriceAnnouncement extends EntityBase {
  public BranchIds?: number[];
  public IncreaseRateOfAmount?: number;
  public AmountTypeId?: number;
  public AmountTypeTitle?: string;
  public AmountTypeCode?: number;
  public RoundingAmount?: number;
  public RoundingTypeId?: number;
  public RoundingTypeTitle: string;
  public RoundingTypeCode?: number;
  public ShamsiDateField: string;
  public Zones: ZonePriceAnnouncementForm[];
}

export class ZonePriceAnnouncementForm extends EntityBase {
  public ZonePriceAnnouncementId?: number;
  public ZoneTitle: string;
  public ZoneBranchId: number;
  public ZoneId: number;
  public BranchId?: number;
  public BranchTitle?: string;
  public ZoneBranch :ZoneBranch;
  public OldAmount?: number;
  public OldAmountDriver?: number;
  public NewAmount?: number;
  public NewAmountDriver?: number;
  public IncreaseRateOfAmount?: number;
}
